"use strict";
'use es6';
/**
 * Fork of UIComponents/nav/UINestedNav
 * https://git.hubteam.com/HubSpot/UIComponents/blob/f5f8211/UIComponents/static-2.3729/js/nav/UINestedNav.js
 */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NavList = _interopRequireDefault(require("./NavList"));

var _HR = _interopRequireDefault(require("UIComponents/elements/HR"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H7"));

var NestedNav = (0, _createReactClass.default)({
  displayName: 'NestedNav',
  propTypes: (0, _extends2.default)({}, _NavList.default.propTypes, {
    divider: _propTypes.default.bool,
    headingText: _propTypes.default.node
  }),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _NavList.default.defaultProps, {
      divider: false,
      headingText: ''
    });
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        divider = _this$props.divider,
        headingText = _this$props.headingText,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "divider", "headingText"]);
    return _react.default.createElement(_NavList.default, (0, _extends2.default)({}, rest, {
      className: className,
      _rootComponent: NestedNav
    }), divider ? _react.default.createElement(_HR.default, null) : null, headingText ? _react.default.createElement(_H.default, null, headingText) : null, children);
  }
});
var _default = NestedNav;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/nav/NestedNav.js
// module id = 204
// module chunks = 209 210 211 212